import React from 'react';
import { Label, Price, Typography } from 'fronton-react';
import { BookmarkSimpleIcon } from '@fronton/icons-react';
import { TRoomsParams } from 'common/types/floor-params.type';
import { TProjectConfiguration } from 'pages/common/types';
import { getRoomTypeTitle } from 'pages/common/helpers/get-room-type-title';
import { CardWidth, DEFAULT_IMAGES_COUNT, IMAGES_COUNT_BY_WIDTH } from '../../constants';
import {
  cardFooter,
  cardHeader,
  imagesContainer,
  projectCardContainer,
  projectImage,
  projectPrice,
  СardTitleContainer,
} from './styles';

type TProjectCardProps = {
  project: TProjectConfiguration;
  cardWidth: CardWidth;
  fullWidth?: boolean;
};

export const ProjectCard: React.FC<TProjectCardProps> = ({ project, cardWidth, fullWidth = false }) => {
  const roomType = project.projectConfigurationParameters.find(el => el.key === 'roomType')?.value;
  const roomTypeTitle = getRoomTypeTitle({ room: { roomType } as TRoomsParams, translate: undefined });
  const roomSize = project.projectConfigurationParameters.find(el => el.key === 'area')?.value;
  const roomLabel = roomSize ? `${roomTypeTitle} ${roomSize} м²` : roomTypeTitle;
  const cardTitle = project?.generalItems?.find(el => !el.complementary)?.name ?? '';

  const maxImagesCount = IMAGES_COUNT_BY_WIDTH[cardWidth] || DEFAULT_IMAGES_COUNT;
  const imagesToShow = project?.generalItems?.filter(item => item?.image).slice(0, maxImagesCount) ?? [];

  return (
    <div
      className={projectCardContainer}
      style={{ width: fullWidth ? '100%' : `${cardWidth}px` }}
      data-testid="project-card">
      <div className={cardHeader}>
        <Label background="background-primary" color="text-primary" data-testid="room-label">
          {roomLabel}
        </Label>
        <BookmarkSimpleIcon type="fill" size="l" color="control-hover-accent" />
      </div>

      {cardTitle && (
        <СardTitleContainer data-testid="project-title">
          <Typography size="subtitle" variant="s">
            {cardTitle}
          </Typography>
        </СardTitleContainer>
      )}

      <div className={cardFooter}>
        <div className={imagesContainer} data-testid="project-images">
          {imagesToShow.map(item => (
            <img
              key={item.code}
              src={item.image}
              alt={item?.name}
              loading="lazy"
              width={40}
              height={40}
              className={projectImage}
            />
          ))}
        </div>
        {!!project?.approximateTotalAmount && (
          <Price
            align="right"
            fraction
            size="m"
            units="₽"
            value={project.approximateTotalAmount}
            variant="medium"
            className={projectPrice}
          />
        )}
      </div>
    </div>
  );
};
